module.exports = __webpack_public_path__ + "media/sofa_marker_cn.a5b970a6.mp4";